var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AnsweringFeedback {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get passedFeedbackTime() {
        const { tickingTime } = this.question.context.app.appClock.clock_100;
        if (!this.question.answer)
            return 0;
        if (!this.question.answer.completeDate)
            return 0;
        return tickingTime - this.question.answer.completeDate.getTime();
    }
    remainingFeedbackTime_cached;
    get remainingFeedbackTime() {
        if (this.question.context.app.appClock.isAppClockPaused && this.remainingFeedbackTime_cached)
            return this.remainingFeedbackTime_cached;
        const remainingTimeInMilliseconds = this.feedbackTime - this.passedFeedbackTime;
        const time = Math.max(remainingTimeInMilliseconds, this.remainingAudioPlayTime, this.remainingVideoPlayTime);
        this.remainingFeedbackTime_cached = time;
        return time;
    }
    get remainingFeedbackTimeInSeconds() {
        return Math.ceil(this.remainingFeedbackTime / 1000);
    }
    get remainingAudioPlayTime() {
        if (!runtime.availablePackages.Defer)
            return 0;
        return this.question.context.app.mediaPlayer.playerChannels.channelVoice.channelInfo.remainingBusyTimeInSeconds * 1000;
    }
    get remainingVideoPlayTime() {
        return 0;
        /*  return (
          1000 *
          this.question.context.app.stage.stageMountedActors.mountedActors
            .filter(a => a.type === 'video')
            .reduce((max: number, video: AttachedVideo) => Math.max(max, video.remainingPlaytimeInSeconds), 0)
        ); */
    }
    get feedbackTime() {
        const basicFeedbackTime = this.question.core.valueOf.feedbackTime;
        return basicFeedbackTime;
    }
    get feedbackText() {
        return '';
    }
    get earlyTime() {
        if (runtime.browserRuntime && runtime.browserRuntime.browserDevice.isTabletOrSmartphone)
            return 650;
        return 100;
    }
    get isFeedbackTimeNearlyOver() {
        if (!this.question.answeringState.isInFeedbackState)
            return false;
        if (this.question.answeringFeedback.remainingFeedbackTime > this.earlyTime)
            return false;
        return true;
    }
}
__decorate([
    computed
], AnsweringFeedback.prototype, "passedFeedbackTime", null);
__decorate([
    computed
], AnsweringFeedback.prototype, "remainingFeedbackTime", null);
__decorate([
    computed
], AnsweringFeedback.prototype, "remainingFeedbackTimeInSeconds", null);
__decorate([
    computed
], AnsweringFeedback.prototype, "remainingVideoPlayTime", null);
__decorate([
    computed
], AnsweringFeedback.prototype, "feedbackText", null);
__decorate([
    computed // avoid rerender of <CycleBarCountdownTime>
], AnsweringFeedback.prototype, "isFeedbackTimeNearlyOver", null);
